<template>
  <div>
    <el-dialog
      :visible.sync="show"
      width="442px"
      :close-on-click-modal="false"
      style="
        background: linear-gradient(
          180deg,
          rgba(255, 255, 255, 0.6) 0%,
          rgba(255, 255, 255, 0) 100%
        );
      "
    >
      <div>
        <div>
          <p
            style="
              font-size: 20px;
              line-height: 20px;
              margin: 0px;
              orphans: 0;
              text-align: center;
              widows: 0;
            "
          >
            <el-image
              style="position: relative; top: -10px"
              :src="require('../../../assets/images/3.png')"
            />
            <span
              style="
                font-family: 仿宋;
                font-size: 28px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #131295;
                position: relative;
                top: -20px;
                margin: 0 10px;
              "
            >风险提示</span>
            <el-image
              style="position: relative; top: -10px"
              :src="require('../../../assets/images/4.png')"
            />
          </p>
          <p
            style="
              font-size: 13px;
              line-height: 20px;
              margin: 0px;
              orphans: 0;
              text-align: center;
              widows: 0;
            "
          >
            <span
              style="font-family: 仿宋; font-size: 13px; font-weight: bold"
            >&#xa0;</span>
          </p>
          <div
            class="main"
            style="padding: 10px;height:270px"
          >
            <p
              style="
                font-size: 16px;
                line-height: 22px;
                margin: 0px;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span
                style="
                  font-size: 16px;
                  font-family: PingFangSC-Semibold, PingFang SC;
                  font-weight: 600;
                  color: #f24b69;
                  line-height: 22px;
                "
              >尊敬的交易商：</span>
            </p>
            <p
              style="
                font-size: 13px;
                line-height: 20px;
                margin: 0px;
                orphans: 0;
                margin-top: 6px;
                widows: 0;
              "
            >
              <span
                style="
                  font-size: 16px;
                  font-family: PingFangSC-Semibold, PingFang SC;
                  font-weight: 600;
                  color: rgba(19, 18, 149, 0.8);
                  line-height: 22px;
                "
              >
                商品交易业务对交易商的风险承受能力、理解风险的程度、风险控制能力以及现货交易经验有一定的要求，为了让交易商充分了解商品交易业务的风险，{{ APP_WINNY_NAME }}（以下简称“{{ APP_WINNY_NAME }}”）特提供本《风险告知书》。请交易商务必仔细阅读了解本《风险告知书》的所有内容，只有在交易商确认本《风险告知书》后，方可办理申请开户手续。若交易商选择继续签署《交易商入市协议书》，则视为交易商已充分认知、了解本告知书载明的风险，并自愿承担参与商品交易业务带来的风险。</span>
            </p>
          </div>
          <div class="btnWrap">
            <!-- <div class="nextStepBtn" @click="goFalse">取消</div> -->
            <div
              class="nextStepBtn sureBtn"
              style="
                  width: 100%;
                  height: 40px;
                  background: #0f40b9;
                  border-radius: 4px;
                  margin: 0 auto;
                "
              @click="goOk"
            >
              点击了解详情
            </div>
          </div>
        </div>
      </div>
      <div class="dotStyle">
        {{ countDown }}
      </div>
      <div class="closeTk">
        <img src="../../../assets/images/close1.png" alt="" @click="goFalse">
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: false,
      countDown: 5,
      countInter: null,
      APP_WINNY_NAME: window.g.APP_WINNY_NAME
    }
  },
  mounted() {
    this.calcTime()
  },
  destroyed() {
    if (this.countInter) {
      clearInterval(this.countInter)
      this.countInter = null
    }
  },
  methods: {
    showDia() {
      this.show = true
    },
    calcTime() {
      this.countInter = setInterval(() => {
        this.countDown--
        if (this.countDown <= 0) {
          this.show = false
          this.$emit('confirm', 0)
        }
      }, 1000)
    },
    goFalse() {
      this.show = false
      this.$emit('confirm', 0)
    },
    goOk() {
      this.show = false
      this.$emit('confirm', 1)
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .el-dialog {
  background: linear-gradient(
    265deg,
    rgba(255, 255, 255, 0.6) 0%,
    rgba(255, 255, 255, 0) 100%
  );
  background: url("../../../assets/images/1.png") no-repeat;
  background-size: 100% 100%;
}
/deep/.el-dialog__header{
    display: none;
}
/deep/.el-dialog__body{
  padding:40px 10px 10px 10px;
}
.main {
  background: url("../../../assets/images/2.png") no-repeat;
  background-size: 100% 150%;
  min-height: 270px;
}
/deep/ .el-dialog__footer {
  display: none;
}
.btnWrap {
  display: flex;
  padding: 10px 0;
  .nextStepBtn {
    // flex: 1;
    height: 40px;
    line-height: 40px;
    text-align: center;
    margin: 0 auto;
  }
}
.dotStyle{
    position: absolute;
    z-index: 2002;
    bottom: -40px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color:  rgba(178, 178, 178, 1);
    left: calc(50% - 15px);
    color:rgba(255,255,255,0.6);
    text-align: center;
    line-height: 30px;
  }
  .closeTk{
    position: absolute;
    z-index: 2002;
    right: -390px;
    width: 100%;
    top: -40px;
    cursor: pointer;
    img{
      width:28px;
    }
  }
.btnWrap > div:first-child {
  margin-right: 20px;
  color: #fff;
  background-color: transparent;
  // border: 1px solid #979797;
}
.sureBtn {
  background-color: #2483ff;
  color: #fff;
}
</style>
